var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 47357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.0588 15.5506V42.08C53.0588 43.7687 52.388 45.3881 51.194 46.5822C49.9999 47.7762 48.3804 48.4471 46.6918 48.4471H6.36706C4.67841 48.4471 3.05892 47.7762 1.86487 46.5822C0.670813 45.3881 0 43.7687 0 42.08V15.5506C0 13.8619 0.670813 12.2425 1.86487 11.0484C3.05892 9.85435 4.67841 9.18353 6.36706 9.18353H9.55059V39.9576H43.5082V32.5294H44.5694C45.4137 32.5294 46.2235 32.194 46.8205 31.597C47.4175 31 47.7529 30.1902 47.7529 29.3459V22.9788C47.7529 22.1345 47.4175 21.3248 46.8205 20.7277C46.2235 20.1307 45.4137 19.7953 44.5694 19.7953H43.5082V14.4894L38.2024 9.18353H46.6918C48.3804 9.18353 49.9999 9.85435 51.194 11.0484C52.388 12.2425 53.0588 13.8619 53.0588 15.5506Z",
    fill: "url(#paint0_linear_8358_15538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 39.9576H53.0588V42.08C53.0588 43.7686 52.388 45.3881 51.194 46.5822C49.9999 47.7762 48.3804 48.4471 46.6918 48.4471H6.36706C4.67841 48.4471 3.05892 47.7762 1.86487 46.5822C0.670813 45.3881 0 43.7686 0 42.08V39.9576Z",
    fill: "url(#paint1_linear_8358_15538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.5898 45.2635H25.4674C25.186 45.2635 24.9161 45.1517 24.7171 44.9527C24.5181 44.7537 24.4062 44.4838 24.4062 44.2024C24.4062 43.9209 24.5181 43.651 24.7171 43.452C24.9161 43.253 25.186 43.1412 25.4674 43.1412H27.5898C27.8712 43.1412 28.1411 43.253 28.3401 43.452C28.5392 43.651 28.651 43.9209 28.651 44.2024C28.651 44.4838 28.5392 44.7537 28.3401 44.9527C28.1411 45.1517 27.8712 45.2635 27.5898 45.2635Z",
    fill: "#F0F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.8355 29.3459L28.652 32.5294H43.5084V39.9576H9.55078V8.12235C9.55078 7.55947 9.77439 7.01964 10.1724 6.62162C10.5704 6.2236 11.1103 6 11.6731 6H35.019L43.5084 14.4894V19.7953H35.019C34.1747 19.7953 33.3649 20.1307 32.7679 20.7277C32.1709 21.3248 31.8355 22.1345 31.8355 22.9788V29.3459Z",
    fill: "url(#paint2_linear_8358_15538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.5089 14.4894H37.1419C36.579 14.4894 36.0392 14.2658 35.6412 13.8678C35.2431 13.4698 35.0195 12.9299 35.0195 12.3671V6L43.5089 14.4894Z",
    fill: "#EB7F58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.529 16.6117C26.5279 17.7283 26.2331 18.8249 25.6744 19.7916C25.1156 20.7582 24.3125 21.561 23.3455 22.1193V26.1623H22.2843C22.0029 26.1623 21.733 26.2741 21.534 26.4731C21.335 26.6722 21.2232 26.9421 21.2232 27.2235C21.2232 27.505 21.335 27.7749 21.534 27.9739C21.733 28.1729 22.0029 28.2847 22.2843 28.2847H23.3455V29.3459H22.2843C22.0029 29.3459 21.733 29.4577 21.534 29.6567C21.335 29.8557 21.2232 30.1256 21.2232 30.407C21.2232 30.6885 21.335 30.9584 21.534 31.1574C21.733 31.3564 22.0029 31.4682 22.2843 31.4682H23.3455V33.5906L20.162 35.7129L16.9784 33.5906V22.1193C16.0103 21.5603 15.2064 20.7563 14.6475 19.788C14.0887 18.8198 13.7946 17.7215 13.7949 16.6036C13.7952 15.4857 14.0898 14.3875 14.6492 13.4196C15.2085 12.4516 16.0128 11.648 16.9813 11.0896C17.9497 10.5311 19.0481 10.2374 20.1661 10.2382C21.284 10.2389 22.382 10.5339 23.3497 11.0936C24.3175 11.6533 25.1208 12.458 25.6789 13.4266C26.237 14.3953 26.5302 15.4938 26.529 16.6117Z",
    fill: "#F0F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.1614 16.6117C21.3336 16.6117 22.2838 15.6615 22.2838 14.4894C22.2838 13.3172 21.3336 12.367 20.1614 12.367C18.9893 12.367 18.0391 13.3172 18.0391 14.4894C18.0391 15.6615 18.9893 16.6117 20.1614 16.6117Z",
    fill: "#FE9661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M47.7535 22.9788V29.3459C47.7535 30.1902 47.4181 30.9999 46.8211 31.597C46.2241 32.194 45.4143 32.5294 44.57 32.5294H28.6523L31.8359 29.3459V22.9788C31.8359 22.1345 32.1713 21.3247 32.7683 20.7277C33.3653 20.1307 34.1751 19.7953 35.0194 19.7953H44.57C45.4143 19.7953 46.2241 20.1307 46.8211 20.7277C47.4181 21.3247 47.7535 22.1345 47.7535 22.9788Z",
    fill: "url(#paint3_linear_8358_15538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M43.5089 25.1012H36.0807C35.7993 25.1012 35.5294 24.9894 35.3303 24.7904C35.1313 24.5914 35.0195 24.3214 35.0195 24.04C35.0195 23.7586 35.1313 23.4886 35.3303 23.2896C35.5294 23.0906 35.7993 22.9788 36.0807 22.9788H43.5089C43.7904 22.9788 44.0603 23.0906 44.2593 23.2896C44.4583 23.4886 44.5701 23.7586 44.5701 24.04C44.5701 24.3214 44.4583 24.5914 44.2593 24.7904C44.0603 24.9894 43.7904 25.1012 43.5089 25.1012ZM43.5089 29.3459H36.0807C35.7993 29.3459 35.5294 29.2341 35.3303 29.0351C35.1313 28.8361 35.0195 28.5661 35.0195 28.2847C35.0195 28.0033 35.1313 27.7333 35.3303 27.5343C35.5294 27.3353 35.7993 27.2235 36.0807 27.2235H43.5089C43.7904 27.2235 44.0603 27.3353 44.2593 27.5343C44.4583 27.7333 44.5701 28.0033 44.5701 28.2847C44.5701 28.5661 44.4583 28.8361 44.2593 29.0351C44.0603 29.2341 43.7904 29.3459 43.5089 29.3459Z",
    fill: "#F0F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M35.0179 59.0588H18.0391L20.1614 48.447H32.8955L35.0179 59.0588Z",
    fill: "#4795EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M37.1402 60.12H15.9166C15.6352 60.12 15.3653 60.0082 15.1663 59.8092C14.9673 59.6102 14.8555 59.3403 14.8555 59.0589C14.8555 58.7774 14.9673 58.5075 15.1663 58.3085C15.3653 58.1095 15.6352 57.9977 15.9166 57.9977H37.1402C37.4216 57.9977 37.6915 58.1095 37.8905 58.3085C38.0895 58.5075 38.2013 58.7774 38.2013 59.0589C38.2013 59.3403 38.0895 59.6102 37.8905 59.8092C37.6915 60.0082 37.4216 60.12 37.1402 60.12Z",
    fill: "#54A5FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8358_15538",
    x1: 0,
    y1: 28.8153,
    x2: 53.0588,
    y2: 28.8153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8358_15538",
    x1: 0,
    y1: 44.2023,
    x2: 53.0588,
    y2: 44.2023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AD3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8358_15538",
    x1: 9.55078,
    y1: 22.9788,
    x2: 43.5084,
    y2: 22.9788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB369"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8358_15538",
    x1: 28.6523,
    y1: 26.1623,
    x2: 47.7535,
    y2: 26.1623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AD3FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyword);
export default __webpack_public_path__ + "static/media/keyword.41b4e6a2e074a79df216e9d11ea40b61.svg";
export { ForwardRef as ReactComponent };